import { Theme } from "@mui/material/styles";

const styles = (theme: Theme) => ({
  root: {
    marginTop: theme.spacing(2),
    display: "grid",
    gridTemplateColumns: "1fr",
    gridTemplateRows: "auto",
    gridRowGap: theme.spacing(1.25),
    [theme.breakpoints.up("md")]: {
      width: "50%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  section: {
    marginTop: theme.spacing(2),
    width: "100%",
  },
  formControl: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    "& > .MuiBox-root": {
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
    "& .MuiCheckbox-root": {
      "& .MuiSvgIcon-root": { fontSize: 16 },
      color: `${theme.palette.primary.main} !important`,
      "&.Mui-checked": {
        color: `${theme.palette.primary.main} !important`,
      },
      "&.Mui-disabled": {
        opacity: 1,
        color: `${theme.palette.grey[400]} !important`,
      },
    },
    "& .checkboxStyle": {
      "& .MuiSvgIcon-root": { fontSize: 16 },
      color: `${theme.palette.primary.main} !important`,
      "&.Mui-checked": {
        color: `${theme.palette.primary.main} !important`,
      },
      "&.Mui-disabled": {
        opacity: 1,
        color: `${theme.palette.black[800]} !important`,
      },
    },
    "& .readOnlyCheckboxStyle": {
      "& .MuiSvgIcon-root": { fontSize: 16 },
      color: `${theme.palette.primary.main} !important`,
      "&.Mui-checked": {
        color: `${theme.palette.primary.main} !important`,
      },
      "&.Mui-disabled": {
        opacity: 1,
        color: `${theme.palette.grey[800]} !important`,
      },
    },
    "& .disabledLabel": {
      marginLeft: theme.spacing(1),
      marginTop: theme.spacing(2),
      "& .MuiFormControlLabel-label": {
        fontSize: "0.75rem",
      },
      "&.Mui-disabled": {
        marginLeft: theme.spacing(1),
        marginTop: theme.spacing(2),
        cursor: "not-allowed !important",
      },
    },
    "& > .MuiBox-root.readOnlyTable": {
      cursor: "not-allowed !important",
    },
  },
});

export const mainStyles = (theme: Theme) => ({
  toolbarContainer: {
    display: "flex",
    alignItems: "center",
    minHeight: "48px",
    width: "100%",
    "& .MuiStack-root": {
      justifyContent: "flex-end",
    },
    "& .MuiTextField-root": {
      minWidth: "150px",
      maxWidth: "150px",
      marginRight: theme.spacing(2),
    },
  },
  datagridContainer: {
    flex: 1,
    minHeight: "300px",
    width: "100%",
    overflow: "hidden",
    "& .MuiDataGrid-root": {
      height: "100% !important",
      maxHeight: "100% !important",
      display: "flex",
      flexDirection: "column",
    },
    "& .MuiDataGrid-main": {
      flex: "1 1 auto",
      overflow: "auto",
      minHeight: 0,
    },
    "& .MuiDataGrid-virtualScroller": {
      flex: "1 1 auto",
      overflow: "auto",
    },
    "& .MuiDataGrid-footerContainer": {
      flex: "0 0 auto",
      minHeight: "52px",
    },
  },
});

export default styles;
